export const baseUrl = "https://apilearning.ingagemetaverse.com/";
export const baseUrlNoEndSlash = "https://apilearning.ingagemetaverse.com/";

// export const baseUrl = "http://127.0.0.1:8000/";
// export const baseUrlNoEndSlash = "http://127.0.0.1:8000/";